// 登录态续期：后端在 token 快过期时会回一个 X-Refreshed-Token，
// 这里统一接住并写回本地，避免用户隔天就被踢去重新登录。
import axios from 'axios';

let installed = false;

export function installAuthTokenRefresh() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    res => {
      const fresh = res?.headers?.['x-refreshed-token'];
      if (fresh) {
        try {
          localStorage.setItem('steam_token', fresh);
        } catch (e) {
          // 隐私模式下写不进去也不影响本次会话
        }
        // 同步到 zustand，避免内存里继续用旧 token；动态引入避免循环依赖
        import('../store/authStore')
          .then(({ useAuthStore }) => {
            try { useAuthStore.setState({ token: fresh }); } catch (e) {}
          })
          .catch(() => {});
      }
      return res;
    },
    err => Promise.reject(err)
  );
}
